import { UserData } from '../../dto/user-data';

export class UsersContainerPopupInput {
  constructor(
    public users: UserData[],
    public value: string[] | string | null,
    public canEdit: boolean,
    public multiSelect: boolean
  ) {}
}
